const focus = (id) => {
  try {
    document.getElementById(id).focus()
  } catch (e) {}
}

export default focus
